<template>
  <div class="sales">
    <div class="sales-top">
      <div class="sales-top__name">广告费,库存量,退货量,销量</div>
    </div>
    <tips class="sales-tip">
      <div class="sales-tip__line"> 上期月结数据汇总日期： 2025-10-01 ~ 下期月结数据汇总日期： 2025-10-31 &nbsp;&nbsp;(请严格按日期更新!)</div>
    </tips>
    <div class="sales-table">
      <Table :head="salesTableHead" width="1654" height="550"></Table>
    </div>
  </div>
</template>

<script>
import { AnalysisNewModule } from './class'
import Table from 'components/common/Table.vue'
import tips from '../common/tips.vue';
export default {
  name: 'advertisingAndSalesNum',
  components: {
    Table, tips
  },
  data(){
    return {
      /**订单数量表头 */
      salesTableHead: AnalysisNewModule.NEWSALESTABLEHEAD()
    }
  }
}
</script>

<style lang="scss" scoped>
.sales{
  width: 1800px;
  &-top{
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 10px 0;
    &__name{
      font-size: 16px;
      font-weight: bold;
      color: black;
    }
    &__btn{
      line-height: 30px;
      padding: 0 30px;
      color: white;
      background: #00a0c7;
      margin-left: 10px;
      &:hover{
        cursor: pointer;
        opacity: .8;
      }
    }
  }
}
</style>
